module.exports = __webpack_public_path__ + "img/antes_despues_01.613a23fc.png";